var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 119,
    viewBox: "0 0 120 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vscode-icons:file-type-css"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.1325 101.154L13.71 7.4375H106.29L97.8562 101.139L59.9437 111.562L22.1325 101.154Z",
    fill: "#1572B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60 103.597L90.6375 95.174L97.845 15.1019H60V103.597Z",
    fill: "#33A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M60 49.054H75.3375L76.395 37.2842H60V25.7896H89.0625L88.785 28.8724L85.9387 60.5487H60V49.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.0711 78.9045L60.0186 78.9193L47.1112 75.4609L46.2862 66.2942H34.6499L36.2737 84.3413L60.0149 90.8788L60.0711 90.864V78.9045Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M74.3513 60.0615L72.9563 75.4534L60.03 78.9119V90.8714L83.79 84.3412L83.9663 82.4001L85.98 60.0615H74.3513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M60.0411 25.7896V37.2842H32.0436L31.8111 34.6997L31.2824 28.8724L31.0049 25.7896H60.0411ZM59.9999 49.054V60.5487H47.2536L47.0211 57.9642L46.4961 52.1369L46.2186 49.054H59.9999Z",
    fill: "#EBEBEB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.f0a058565e1465bfb7ff1689b0eac1a2.svg";
export { ForwardRef as ReactComponent };